<div class="app-page-not-found">
  <app-error-page
    [errorPageIsGoBackHomeVisible]="false"
    [errorPageTitle]="title"
    [errorPageDescription]="description"
  ></app-error-page>
</div>
